import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyFeatureFlagUsage = loadable(() => import(/* webpackChunkName: "content/examples/feature-flag-usage" */ './ExampleFeatureFlagUsage'), 'ExampleFeatureFlagUsage');
